"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ReactDOM = tslib_1.__importStar(require("react-dom"));
const { useState, useEffect } = React;
exports.Portal = ({ children }) => {
    const [wrapper] = useState(() => {
        if (typeof document !== 'undefined') {
            const wrapperIn = document.createElement('div');
            document.body.appendChild(wrapperIn);
            return wrapperIn;
        }
        return undefined;
    });
    useEffect(() => () => {
        if (wrapper !== undefined) {
            document.body.removeChild(wrapper);
        }
    }, [wrapper]);
    if (wrapper === undefined) {
        return null;
    }
    return ReactDOM.createPortal(children, wrapper);
};

//# sourceMappingURL=Portal.js.map
